import flag from 'constants/featureFlags';
import withFeatureFlag from './withFeatureFlag';

export default withFeatureFlag;
export { flag };
